
import { defineComponent, PropType } from "vue";

import common from "../styles/common.module.less";
import { Icon } from "./icons";

// 页码序列：页数少时全展示，多时用省略号收敛到当前页附近
function pageItems(page: number, pageCount: number): Array<number | string> {
  if (pageCount <= 7) {
    return Array.from({ length: pageCount }, (_, i) => i + 1);
  }
  const items: Array<number | string> = [1];
  const start = Math.max(2, page - 2);
  const end = Math.min(pageCount - 1, page + 2);
  if (start > 2) items.push("dots-start");
  for (let i = start; i <= end; i += 1) items.push(i);
  if (end < pageCount - 1) items.push("dots-end");
  items.push(pageCount);
  return items;
}

export default defineComponent({
  name: "XiyouPaginationBar",
  props: {
    page: { type: Number, required: true },
    pageCount: { type: Number, required: true },
    onChange: {
      type: Function as PropType<(page: number) => void>,
      default: undefined,
    },
  },
  setup(props) {
    const go = (next: number) => {
      if (next < 1 || next > props.pageCount || next === props.page) return;
      if (props.onChange) props.onChange(next);
    };
    return () => (
      <div class={common.pager}>
        <button
          type="button"
          class={[
            common.pagerBtn,
            props.page <= 1 ? common.pagerDisabled : null,
          ]}
          onClick={() => go(props.page - 1)}
        >
          <Icon name="chevron-left" />
        </button>
        {pageItems(props.page, props.pageCount).map((item) =>
          typeof item === "number" ? (
            <button
              key={item}
              type="button"
              class={[
                common.pagerItem,
                item === props.page ? common.pagerActive : null,
              ]}
              onClick={() => go(item)}
            >
              {item}
            </button>
          ) : (
            <span key={item} class={common.pagerDots}>
              …
            </span>
          )
        )}
        <button
          type="button"
          class={[
            common.pagerBtn,
            props.page >= props.pageCount ? common.pagerDisabled : null,
          ]}
          onClick={() => go(props.page + 1)}
        >
          <Icon name="chevron-right" />
        </button>
      </div>
    );
  },
});
